import React, { cloneElement } from 'react';
import { usePortaledTooltip } from './hooks/usePortaledTooltip';

/**
 * Material-inspired tooltip for the AI chat panel. Portals to document.body so
 * labels are not clipped by the scrollable message list.
 *
 * @param {{
 *   title: string,
 *   placement?: 'top',
 *   children: React.ReactElement,
 * }} props
 */
export default function AiChatTooltip({ title, placement = 'top', children }) {
  const {
    tooltipId,
    triggerRef,
    open,
    scheduleShow,
    scheduleHide,
    renderPopper,
  } = usePortaledTooltip({ placement });

  const trigger = cloneElement(children, {
    ref: (node) => {
      triggerRef.current = node;
      const { ref } = children;
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    },
    onMouseEnter: (e) => {
      children.props.onMouseEnter?.(e);
      scheduleShow();
    },
    onMouseLeave: (e) => {
      children.props.onMouseLeave?.(e);
      scheduleHide();
    },
    onFocus: (e) => {
      children.props.onFocus?.(e);
      scheduleShow();
    },
    onBlur: (e) => {
      children.props.onBlur?.(e);
      scheduleHide();
    },
    'aria-describedby': open ? tooltipId : undefined,
  });

  return (
    <span className="ddv-ai-chat-tooltip">
      {trigger}
      {renderPopper(title)}
    </span>
  );
}
